var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-other-products"},_vm._l((_vm.otherProducts),function(item){return _c('div',{key:item.id,staticClass:"m-other-products-item",on:{"click":function($event){return _vm.onClick(item.pkgname)}}},[_c('img',{attrs:{"src":require(`@/assets/images/mobile/container/downloads/pic_${item.id}.png`)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }